module.exports = __webpack_public_path__ + "assets/src/gurooLoading.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/preloader/gurooLoading.gif
 ** module id = 1089
 ** module chunks = 0
 **/